<template>
  	<div>
		<v-layout wrap align-start justify-space-between pt-3>
			<template v-for="(area, index) in areas">
				<v-flex xs6 :key="area.id" :class="index === 0 ? 'pr-3' : 'pl-3'">
					<rows-factors
						:rows="area.entities"
						:title="area.name"
						@check="rowCheckSelect($event, area)"
						@select-factor="$emit('select-factor', $event)"
					/>
				</v-flex>
			</template>
		</v-layout>
	</div>
</template>

<script>
import progressBar from '@/components/shared/progress-bar';
import rowsFactors from '@/components/surveys/rows-factors';

function rowCheckSelect(entity, areaSelected) {
	const { value: typeSelected } = areaSelected;
	this.model[typeSelected] = areaSelected.entities.filter(factor => factor.selected);
	const newRows = areaSelected.entities.map((row) => {
		const newRow = { ...row };
		if (!row.selected) {
			newRow.disabled = this.model[typeSelected].length === 5;
		}
		return newRow;
	});
	this.$set(areaSelected, 'entities', newRows);
	this.$emit('row-check-select', areaSelected, entity);
}

function data() {
	return {
		model: {
			arraySelected: [],
			arraySelectedComunication: [],
		},
	};
}

export default {
	name: 'step-one',
	components: {
		progressBar,
		rowsFactors,
	},
	data,
	methods: {
		rowCheckSelect,
	},
	props: {
		areas: {
			default: () => [],
			type: Array,
		},
	},
};
</script>

<style lang="scss" scoped>
	.table-factors {
		margin-bottom: auto;
		margin-top: 28px;
	}
</style>



// WEBPACK FOOTER //
// src/components/surveys/step-one.vue